import React from 'react';

const TextField = ({
    type = '',
    classes = '',
    inputProps = {},
    onChangeText = () => {}
} = props) => {
    const __classNames = [
            'wobo-text-field', 
            (type ? type : null),
            (classes ? classes : null)
        ]
        .filter( name => name)
        .join(' ');
    return (
        <>
        <input type='text' 
            className={__classNames} 
            {...inputProps} 
            onChange={(e) => onChangeText(e)}
        />
        </>
    )
}

export default TextField;